import axios from 'axios'
import { useCookies } from 'vue3-cookies'

const { cookies } = useCookies()

const instance = axios.create({
  baseURL: process.env.VUE_APP_LMS_URL,
})
// export default instance;

let getAccess = ''
let getRefresh = ''
let headers = ''

export async function loadfaq() {
  // console.log(instance);
  // eslint-disable-next-line no-return-await
  return await instance
    .get('/api/v1/board/faq')
    .then((response) => response.data)
}

// eslint-disable-next-line consistent-return
export async function loadNotice(page, sort) {
  try {
    // eslint-disable-next-line camelcase
    const page_start = 1
    // eslint-disable-next-line camelcase
    const page_size = 10
    // eslint-disable-next-line camelcase
    const sort_num = sort.value
    if (page == null) {
      const noticeRes = await instance.get(
        // eslint-disable-next-line camelcase
        `/api/v1/board/notice/whole?page_index=${page_start}&page_size=${page_size}&sort=${sort_num}`
      )
      return noticeRes.data
    }

    const noticeRes = await instance.get(
      // eslint-disable-next-line camelcase
      `/api/v1/board/notice/whole?page_index=${page}&page_size=${page_size}&sort=${sort_num}`
    )
    return noticeRes.data

    // return noticeRes.data
  } catch (err) {
    console.log(err)
  }
}

export async function loadDetailNotice(noitceId) {
  const noticeDetailRes = await instance.get(
    `/api/v1/board/notice/whole/${noitceId}`
  )
  // // console.log(noticeDetailRes)
  return noticeDetailRes
}

export async function loadInquiry() {
  const inquiryData = await instance.get(`/api/v1/service/qna/category`)
  return inquiryData
}
export async function sendInquiry(
  // eslint-disable-next-line camelcase
  ctg_code,
  name,
  department,
  email,
  phone,
  title,
  content,
  newfile
) {
  // console.log(ctg_code)
  // console.log(email)
  // console.log(phone)
  // console.log(title)
  // console.log(content)
  // console.log(newfile)

  const newPhone = phone.replace(/-/g, '') // 하이픈을 제거하고 새로운 변수에 할당
  // console.log(newPhone); // 출력 결과: 01000001111

  // let headers = {"Authorization" : access_token, "Content-Type": "multipart/form-data" }
  const headers = { 'Content-Type': 'multipart/form-data' }

  try {
    const sendData = {
      // eslint-disable-next-line camelcase
      ctg_code,
      name,
      department,
      email,
      phone: newPhone,
      title,
      content,
      file: newfile,
    }
    await instance.post(`/api/v1/service/qna`, sendData, { headers })

    // const registerInquiry = await instance.post(
    //   `/api/v1/service/qna`,
    //   sendData,
    //   { headers }
    // )
  } catch (err) {
    console.log(err)
  }
}

// 이용문의에 이름 소속 추가시 사용될 함수 시작
// InquiryViews NEW.vue 쓸때 이거 쓰면 됨
// export async function loadDetailNotice(noitceId) {
//   const noticeDetailRes = await instance.get(
//     `/api/v1/board/notice/whole/${noitceId}`
//   )
//   return noticeDetailRes
// }

// export async function loadInquiry() {
//   const inquiryData = await instance.get(`/api/v1/service/qna/category`)
//   return inquiryData
// }
// export async function sendInquiry(
//   // eslint-disable-next-line camelcase
//   ctg_code,
//   name,
//   belong,
//   email,
//   phone,
//   title,
//   content,
//   newfile
// ) {
//   const newPhone = phone.replace(/-/g, '')
//   const headers = { 'Content-Type': 'multipart/form-data' }

//   try {
//     const sendData = {
//       // eslint-disable-next-line camelcase
//       ctg_code,
//       name,
//       belong,
//       email,
//       phone: newPhone,
//       title,
//       content,
//       file: newfile,
//     }
//     await instance.post(`/api/v1/service/qna`, sendData, { headers })
//   } catch (err) {
//     console.log(err)
//   }
// }
// 이용문의에 이름 소속 추가시 사용될 함수 끝

// 콘텐츠 탭
export async function loadContent(page, type, title) {
  try {
    // eslint-disable-next-line camelcase
    const page_start = 1
    // eslint-disable-next-line camelcase
    const page_size = 10
    // const categoryRes = await instance.get(`/api/v1/lecture/intro/category/first`)

    const params = { cfc_name: type, title }
    // console.log("cfc_name", type);
    // console.log("title", title);
    if (!type && !title) {
      // console.log("아무 카테고리고 없음");
      const categoryRes = await instance.get(
        `/api/v1/lecture/intro/category/first`
      )
      const contentRes = await instance.get(
        // eslint-disable-next-line camelcase
        `/api/v1/lecture/intro/contents?page_size=${page_size}&page_index=${page_start}`
      )
      return [categoryRes.data.content, contentRes.data]
    }
    if (page == null || page <= 0) {
      const categoryRes = await instance.get(
        `/api/v1/lecture/intro/category/first`
      )
      const contentRes = await instance.get(
        // eslint-disable-next-line camelcase
        `/api/v1/lecture/intro/contents?page_size=${page_size}&page_index=${page_start}`,
        { params }
      )
      return [categoryRes.data.content, contentRes.data]
    }

    const categoryRes = await instance.get(
      `/api/v1/lecture/intro/category/first`
    )
    const contentRes = await instance.get(
      // eslint-disable-next-line camelcase
      `/api/v1/lecture/intro/contents?page_size=${page_size}&page_index=${page}`,
      { params }
    )
    return [categoryRes.data.content, contentRes.data]
  } catch (err) {
    // console.log(err);
    const categoryRes = await instance.get(
      `/api/v1/lecture/intro/category/first`
    )
    return [categoryRes.data.content, null]
  }
}

// eslint-disable-next-line consistent-return
export async function loadDetailContent(contentsId) {
  getAccess = cookies.get('access_token')
  getRefresh = cookies.get('refresh_token')
  // console.log(getAccess) 미로그인상태면 null값찍힘.
  try {
    if (getAccess !== null) {
      headers = { token: getAccess }
      const contentsDetailRes = await instance.get(
        `/api/v1/lecture/intro/contents/${contentsId}`,
        { headers }
      )
      console.log('contentsDetailRes.data ::: ', contentsDetailRes.data)
      return contentsDetailRes.data
      // eslint-disable-next-line no-else-return
    } else {
      const contentsDetailRes = await instance.get(
        `/api/v1/lecture/intro/contents/${contentsId}`
      )
      console.log('contentsDetailRes.data ::: ', contentsDetailRes.data)
      return contentsDetailRes.data
    }
  } catch (err) {
    console.log(err.response.data)
    return err.response.data
  }
}

// eslint-disable-next-line consistent-return
export async function loadDetailContentNotice(page, contentsId) {
  try {
    // eslint-disable-next-line camelcase
    const page_index = 1
    // eslint-disable-next-line camelcase
    const page_size = 5
    // console.log(page)
    if (page == null) {
      const contentNoticeRes = await instance.get(
        // eslint-disable-next-line camelcase
        `/api/v1/lecture/intro/contents/${contentsId}/notice?page_size=${page_size}&page_index=${page_index}`
      )
      // console.log('1')
      // console.log(contentNoticeRes.data)
      return contentNoticeRes.data
    }
    const contentNoticeRes = await instance.get(
      // eslint-disable-next-line camelcase
      `/api/v1/lecture/intro/contents/${contentsId}/notice?page_size=${page_size}&page_index=${page}`
    )
    // console.log('2')
    // console.log(contentNoticeRes.data)
    return contentNoticeRes.data
  } catch (err) {
    // console.log('3')
    // console.log(err.response.data)
    return err.response.data
    // try {
    //   console.log(contentsId)
    //   const contentNoticeRes = await instance.get(
    //     `/api/v1/lecture/intro/contents/${contentsId}/notice`
    //   )
    //   // console.log(contentNoticeRes);
    //   return contentNoticeRes
    // } catch (err) {
    //   // console.log(err);
    //   return err
  }
}

export async function loadDetailContentNoticeId(contentsId, noticeId) {
  const contentNoticeDetailRes = await instance.get(
    `/api/v1/lecture/intro/contents/${contentsId}/notice/${noticeId}`
  )
  return contentNoticeDetailRes
}

// export async function main_swiper_func(){
//   let main_swiper = new Swiper('.newSwiperContents', {
//     init: false,
//     loop: true,
//     slidesPerView: 1,
//     spaceBetween: 24,
//     autoplay: {
//       delay: 20000,
//     },
//     speed: 1000,
//     navigation: {
//       nextEl: '.swiper-customer-button-next',
//       prevEl: '.swiper-customer-button-prev',
//     },
//     pagination: {
//       el: '.swiper-pagination',
//     },
//   })
//   return main_swiper
// }

// export async function aaa() {
//   let main_swiper = new Swiper('.newSwiperContents', {
//     init: false,
//     loop: true,
//     slidesPerView: 1,
//     spaceBetween: 24,
//     autoplay: {
//       delay: 20000,
//     },
//     speed: 1000,
//     navigation: {
//       nextEl: '.swiper-customer-button-next',
//       prevEl: '.swiper-customer-button-prev',
//     },
//     pagination: {
//       el: '.swiper-pagination',
//     },
//   })
//   main_swiper.init()
//   // alert('a')
// }
